var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ2Out(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 50V40H20v-4h35V26l12.91 12L55 50zM44 61H17V15h27v15h4V11H13v54h35V46h-4v15z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J2_Out.2a725a8c.svg";
export { SvgJ2Out as ReactComponent };